<template>
  <w-popup :state="shareDialogState" class="share-dialog-container flex-column-center" @handleClose="handleClose">
    <template slot="content">
      <div class="flex-center share-dialog-title">分享简历</div>
      <div class="hide-profile-container flex-between">
        <span>隐藏联系方式</span>
        <div class="switch-container" @click.prevent="changeSwitchValue">
          <cube-switch v-model="visibilityType"/>
        </div>
      </div>
      <div class="share-dialog-content flex-between">
        <div v-if="!isHarmony" class="content-item flex-column-center" @click="contentItemClick('wechat')">
          <img src="https://files.wondercv.com/cv-share/weixin.png" alt="">
          <span class="share-text">微信</span>
        </div>
        <div class="content-item flex-column-center" @click="contentItemClick('email')">
          <img src="https://files.wondercv.com/cv-share/email.png" alt="">
          <span class="share-text">邮箱</span>
        </div>
      </div>
      <!-- <div class="share-dialog-bottom flex-center" @click="handleClose">取消</div> -->
    </template>
  </w-popup>
</template>

<script>
  import WPopup from '../../../../components/global/w-popup'
  import { envMixin } from '../../../../assets/js/mixin/global'
  export default {
    mixins: [envMixin],
    props: {
      shareDialogState: {
        type: Boolean,
        default: false
      },
      cvSettings: {
        type: Object,
        default: () => {}
      }
    },
    data(){
      return {
        visibilityType: this.cvSettings.visibility_type === 10
      }
    },
    mounted () {},
    components:{
      WPopup
    },
    watch:{
      'cvSettings.visibility_type': {
        handler(newVal, oldVal) {
          this.visibilityType = newVal === 10
        },
      }
    },
    computed:{},
    methods:{
      handleClose() {
        this.$emit('handleClose')
      },
      contentItemClick(type) {
        this.$emit('contentItemClick', type)
      },
      changeSwitchValue() {
        this.$emit('changeSwitchValue', 'visibility_type')
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../../../../assets/scss/global/variable";
  @import "../../../../assets/scss/global/mixin";
  .share-dialog-container {
    ::v-deep .main {
      display: flex;
      flex-direction: column;
    }
    .share-dialog-title {
      padding: 28px 0 20px;
      width: 100vw;
      font-size: $font-size-medium-x;
      color: $color-title;
      border-bottom: 6px solid #F9F9F9;
    }
    .hide-profile-container {
      width: calc(100vw - 48px);
      padding: 16px 0 20px;
      border-bottom: 1px solid #f9f9f9;
      ::v-deep .cube-switch .cube-switch-input:checked + .cube-switch-ui::after {
        transform: translateX(26px);
      }
      ::v-deep .cube-switch-ui {
        width: 48px;
        height: 22px;
        &:after {
          width: 22px;
        }
      }
      span {
        color: $color-title;
        line-height: 20px;
      }
    }
    .share-dialog-content {
      width: 100%;
      padding: 28px 80px;
      @include ipx-content-bottom(28px);
      .content-item {
        img {
          width: 60px;
          height: 60px;
          object-fit: contain;
          // margin-bottom: 10px;
        }
        .share-text {
          font-size: $font-size-small;
          color: #9c9c9c;
        }
      }
    }
    .share-dialog-bottom {
      width: 100%;
      padding-top: 12px;
      @include ipx-content-bottom(12px);
      color: $color-dark-gray;
      font-size: $font-size-medium-x;
      line-height: 22px;
      border-top: 1px solid #f4f4f4;
    }
  }
</style>